import { trans } from "@/service/i18n/i18n";
import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { getMaxPatronHeight } from "@/service/patron/patron-image";
import { cn } from "@/lib/utils";

export const HorizontalPatron = ({
  patron,
  className = "",
}: {
  patron: PatronVM | null;
  className?: string;
}) => {
  if (!patron || !patron.image || !patron.visible) {
    return <></>;
  }

  const { image, link } = patron;

  return (
    <div className={cn("my-6 flex items-center gap-2", className)}>
      <div className={`text-sm font-semibold`}>{trans("education.patron")}</div>
      <div className={`item-center flex gap-4`}>
        <div className={"flex gap-4"}>
          {link ? (
            <a href={link} target={"_blank"} rel="noreferrer nofollow noopener">
              <PictureUpload
                image={image}
                loaded={true}
                maxHeight={getMaxPatronHeight(image, 0.8)}
                className={"h-full w-auto"}
              />
            </a>
          ) : (
            <PictureUpload
              image={image}
              loaded={true}
              maxHeight={getMaxPatronHeight(image, 0.8)}
              className={"h-full w-auto"}
            />
          )}
        </div>
      </div>
    </div>
  );
};
